<template>
  <div v-if="selectedCount > 0" class="batch-actions">
    <strong>已选择 {{ selectedCount }} 项</strong>
    <div v-if="!selectedFolderId" ref="moveDropdownRef" class="batch-move-dropdown">
      <button type="button" class="btn btn-sm" @click.stop="toggleMoveDropdown">
        批量移动
        <span class="batch-move-caret" aria-hidden="true">▾</span>
      </button>
      <div v-if="isMoveDropdownOpen" class="batch-move-menu" role="menu">
        <button
          v-for="folder in folders"
          :key="folder.id"
          type="button"
          class="batch-move-option"
          role="menuitem"
          @click="onMoveTo(folder.id)"
        >{{ folder.name }}</button>
        <p v-if="!folders.length" class="batch-move-empty">暂无文件夹，请先新建文件夹</p>
      </div>
    </div>
    <button v-else type="button" class="btn btn-sm" @click="$emit('move-out')">批量移出</button>
    <button v-if="canDelete" type="button" class="btn btn-sm danger-outline" @click="$emit('delete')">批量删除</button>
    <button type="button" class="btn btn-sm" @click="$emit('clear')">取消选择</button>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue';

defineProps({
  selectedCount: {
    type: Number,
    default: 0,
  },
  folders: {
    type: Array,
    default: () => [],
  },
  selectedFolderId: {
    type: [String, Number, null],
    default: null,
  },
  canDelete: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['move-to', 'move-out', 'delete', 'clear']);

const isMoveDropdownOpen = ref(false);
const moveDropdownRef = ref(null);

function toggleMoveDropdown() {
  isMoveDropdownOpen.value = !isMoveDropdownOpen.value;
}

function onMoveTo(folderId) {
  isMoveDropdownOpen.value = false;
  emit('move-to', folderId);
}

function handleGlobalClick(event) {
  if (moveDropdownRef.value && !moveDropdownRef.value.contains(event.target)) {
    isMoveDropdownOpen.value = false;
  }
}

onMounted(() => {
  window.addEventListener('click', handleGlobalClick);
});

onUnmounted(() => {
  window.removeEventListener('click', handleGlobalClick);
});
</script>

<style scoped>
.batch-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  flex-wrap: wrap;
}

.batch-actions strong {
  font-size: 12px;
  color: #6d28d9;
}

.batch-move-dropdown {
  position: relative;
}

.batch-move-caret {
  font-size: 10px;
  margin-left: 2px;
}

.batch-move-menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  min-width: 140px;
  max-height: 220px;
  overflow-y: auto;
  background: #ffffff;
  border: 1px solid var(--border-color, #e2e8f0);
  border-radius: 8px;
  box-shadow: 0 10px 25px -5px rgba(15, 23, 42, 0.12), 0 4px 6px -2px rgba(15, 23, 42, 0.05);
  padding: 4px;
  z-index: 50;
  display: flex;
  flex-direction: column;
}

.batch-move-option {
  text-align: left;
  padding: 8px 12px;
  font-size: 12px;
  color: var(--text-dark, #0f172a);
  background: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: background 0.15s ease, color 0.15s ease;
}

.batch-move-option:hover {
  background: #f1f5f9;
  color: var(--color-primary);
}

.batch-move-empty {
  margin: 0;
  padding: 10px 12px;
  font-size: 12px;
  color: var(--text-muted, #94a3b8);
  text-align: center;
  white-space: nowrap;
}

.btn {
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 8px;
  border: 1px solid var(--border-color, #cbd5e1);
  background: #ffffff;
  color: var(--text-dark, #0f172a);
  cursor: pointer;
  transition: all 0.15s ease;
}

.btn:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}

.btn-sm {
  padding: 4px 10px;
  font-size: 12px;
}

.danger-outline {
  border-color: #fca5a5;
  color: #dc2626;
  background: #fff;
}

.danger-outline:hover {
  background: #fef2f2;
  border-color: #f87171;
}
</style>
